import { put, takeLatest } from "redux-saga/effects";
import { call, select } from "redux-saga/effects";
import { modifyMultiPosGiftGroupsApi } from "../../../axios/gift-list";
import { modifyMultiPosGiftGroupsAction } from "../../../constants";
import { selectGiftGroupsByPosId, selectToken } from "../../selectors";
import { SagaIterator } from "redux-saga";
import * as actions from "../../actions";
import { GiftGroupsState } from "../../reducers/gifts-reducers/giftGroupsReducer";
import { notify } from "react-notify-toast";
import Strings from "../../../i18n/strings/giftList";
import { translate } from "../../../helpers/translate";

const t = translate("giftList");

function* modifyMultiPosGiftGroupsSaga(): SagaIterator {
  try {
    const giftGroupsByPosId = yield select(selectGiftGroupsByPosId);
    const payload = Object.entries(
      giftGroupsByPosId as Record<string, GiftGroupsState>
    ).map(([posId, pos]) => ({
      pos_entity_id: posId,
      gift_groups: Object.values(pos.shownGiftGroupsById)
        .sort((a, b) => a.price - b.price)
        .map((group) => ({
          id: group.id,
          name: group.name,
          ar_name: group.ar_name,
          is_ar_renamed: group.is_ar_renamed as 0 | 1,
          is_renamed: group.is_renamed as 0 | 1,
          price: group.price,
          items: group.items.map((item) => ({
            ...(item.is_special_item
              ? {
                  name: item.name,
                  price: item.price,
                  image: item.image,
                  promo_code: item.promo_code,
                  promo_id: item.promo_id,
                }
              : {
                  id: item.id,
                }),
            order: item.order,
            ...(item.is_voucher && { is_voucher: item.is_voucher }),
          })),
        })),
    }));
    const hasInvalidGroupCount = payload.some(
      (pos) => pos.gift_groups.length < 3
    );
    if (hasInvalidGroupCount) {
      notify.show(t(Strings.atLeastThreeGiftGroupsRequired), "error");
      yield put(
        actions.modifyMultiPosGiftGroupsFailure(
          new Error(t(Strings.atLeastThreeGiftGroupsRequired))
        )
      );
      return;
    }

    const token = yield select(selectToken);
    yield call(modifyMultiPosGiftGroupsApi, token, payload);
    yield put(
      actions.modifyMultiPosGiftGroupsSuccess({
        pos_entity_id: payload[0].pos_entity_id,
      })
    );
    notify.show(t(Strings.giftGroupsUpdatedSuccessfully), "success");
  } catch (e) {
    notify.show(t(Strings.failedToUpdateGiftGroups), "error");
    yield put(actions.modifyMultiPosGiftGroupsFailure(e as Error));
  }
}

export function* watchModifyMultiPosGiftGroupsSaga(): SagaIterator {
  yield takeLatest(
    modifyMultiPosGiftGroupsAction.requested,
    modifyMultiPosGiftGroupsSaga
  );
}
